interface SectionTitleProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
}

export default function SectionTitle({ eyebrow, title, desc, align = "center" }: SectionTitleProps) {
  const alignCls = align === "center" ? "mx-auto text-center" : "text-left";
  return (
    <div className={`max-w-2xl ${alignCls}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
        <i className="ri-sparkling-2-line"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl leading-snug text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}